// extracted by mini-css-extract-plugin
export var cyan = "NebulaVideoRow-module--cyan--77e43";
export var hideRow = "NebulaVideoRow-module--hideRow--74855";
export var red = "NebulaVideoRow-module--red--e48fd";
export var root = "NebulaVideoRow-module--root--67ea4";
export var svg = "NebulaVideoRow-module--svg--e7ac1";